import TabAbout from './tabAbout';
export default TabAbout;